/* eslint-disable react/destructuring-assignment */
import React, { Component } from 'react';
import './hotel.css';

class Hotel extends Component {
  renderStar = (quantity) => {
    if (quantity === 0) return null;
    const stars = [1, 2, 3, 4, 5];

    return stars.map((currentValue) => {
      const className
                = currentValue <= quantity
                  ? 'fa fa-star yellow'
                  : 'fa fa-star icon-gray';
      return (
        <div className='inline' key={currentValue}>
          <i className={className} aria-hidden='true' />
        </div>
      );
    });
  }

  render() {
    let tipoHabitacion;
    if (this.props.datos.tipoHabitacion === null) {
      tipoHabitacion = (
        <span className='tipo-habitacion'>
          Tipo de habitacion: A consultar
        </span>
      );
    } else {
      tipoHabitacion = (
        <span className='tipo-habitacion'>
          {(this.props.proveedorId !== undefined && this.props.proveedorId === 1)
            ? `HAB. ${this.props.datos.tipoHabitacion}`
            : `HAB. ${this.props.datos.tipoHabitacion.replace('|', '')}`}
        </span>
      );
    }
    return (
      <div style={{ marginLeft: 15 }}>
        <table>
          <tbody>
            <tr>
              <td>
                <i className='fa fa-hotel' />
                {' '}
                {this.props.datos.nombre}
                <span className='regimen'>
                  {' '}
                  {this.props.datos.regimen}
                </span>
              </td>
            </tr>
            <tr>
              <td>
                {this.renderStar(this.props.datos.clase)}
                {' '}
                <span>
                  {this.props.datos.noches > 0 ? `${this.props.datos.noches} noches` : ''}
                  {' '}
                </span>
                {' '}
                |
                {' '}
                {tipoHabitacion}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  }
}

export default Hotel;
